import { useEffect, useState } from "react";
import { checkProductemail } from "../../../api/product";
import { PMDialog } from "../../utils/PMDialog";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { customerPath, productPath } from "../../Utils";
import { Link } from "react-router-dom";
import { PMNotice } from "../../utils/notifications";
import { debounce } from "lodash";
import { checkCustomerEmail } from "../../../api/customer";

export const CustomerEmailCheck = (props) => {
  const { email, customer } = props;

  const [emailTaken, setEmailTaken] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [foundCustomer, setFoundCustomer] = useState(null);

  const checkEmail = () => {
    checkCustomerEmail({ email: email, fields: "id,displayTitle" }).then(
      (response) => {
        setFoundCustomer(response?.data?.customer);
      }
    );
  };

  useEffect(() => {
    if (foundCustomer && foundCustomer.id !== customer?.id) {
      setDialogOpen(true);
      setEmailTaken(true);
    } else {
      setDialogOpen(false);
      setEmailTaken(false);
    }
  }, [foundCustomer]);

  const debouncedAction = debounce((controller) => {
    checkEmail();
  }, 1000);

  useEffect(() => {
    if (email) debouncedAction();

    // Clean the debounced function on component unmount.
    return () => {
      debouncedAction.cancel();
    };
  }, [email]);

  useEffect(() => {
    if (emailTaken) setDialogOpen(true);
    return () => {};
  }, [emailTaken]);

  return (
    <>
      {emailTaken && (
        <span className="mt-2 flex italic text-red-400 text-xs">
          <ExclamationCircleIcon className="h-4 w-4 mr-1" />
          E-post er opptatt!
        </span>
      )}

      <PMDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <div className="mt-2">
          <PMNotice
            type="error"
            title={"E-post " + email + " er opptatt"}
            description="Velg en annen e-post eller benytt eksisterende kunde."
          />

          <div className="flex justify-between mt-2">
            <button
              type="button"
              onClick={() => setDialogOpen(false)}
              className="px-4 py-2 bg-gray-400 rounded-md text-white"
            >
              Forsett redigering
            </button>
            <Link
              reloadDocument
              to={customerPath({ customer: foundCustomer })}
              className="px-4 py-2 bg-blue-400 rounded-md text-white"
            >
              Gå til kunde
            </Link>
          </div>
        </div>
      </PMDialog>
    </>
  );
};
